<div id="content" class="allcp-form" ng-controller="CustomerAnalyticController">
    <div ng-include="'modules/company/menus/report_menu.html'"></div>
    <div class="row mt20">
        <div class="col-md-12 mb20">
            <div class="panel date-range">
                <div class="panel-body" >
                    <!-- <div class="row">
                        <div class="col-md-6">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body">
                                    <h3 class="mbn mtn text-dark">{{ data.count.total?data.count.total:0 }} </h3>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>Toplam Müşteri</strong>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body">
                                    <h3 class="mbn mtn text-dark">{{ data.count.city?data.count.city:0 }} </h3>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>Farklı Şehir</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr> -->
                    <div class="table-responsive allcp-form" ng-if="data.customers.length > 0">
                        <table class="table table-hover tc-checkbox-1 fs13">

                            <thead>
                            <tr class="bg-light">
                                <th class="text-center"></th>
                                <th>
                                    Partner
                                </th>
                                <th>
                                    Phone
                                </th>
                                <th>
                                    Address
                                </th>
                                <th>On Delivery Orders</th>
                                <th>Completed Orders</th>
                                <th>Unsuccessful Orders</th>
                                <th>Total Orders</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="text-left" ng-repeat="item in data.customers">
                                <td class="text-center">
                                    <label class="option block mn">
                                        <input type="checkbox" 
                                            name="deleted[]"
                                            ng-checked="deleted.indexOf(item.id) > -1"
                                            ng-click="toggleSelection(item.id)">
                                        <span class="checkbox mn"></span>
                                    </label>
                                </td>
                                <td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.customer_name }}</td>
                                <td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.phone_number }}</td>
                                <td class="clickable-row" ng-click="getCustomerDetails(item.id)">{{ item.address }}</td>
                                <td>
                                    {{ item.on_delivery }}
                                </td>
                                <td>
                                    {{ item.success }}
                                </td>
                                <td>
                                    {{ item.fail }}
                                </td>
                                <td>
                                    {{ item.total }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="table-responsive" ng-if="data.customers.length == 0">
                        <div class="alert alert-default pastel">
                            <i class="fa fa-info pr10"></i>
                            <strong>
                                Kayıtlı Müşteriniz bulunamadı! <a href="/yeni-musteri">Buraya</a> tıklayarak Yeni Müşteri kaydı oluşturubilirsiniz.
                            </strong>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
